import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { dailyForecastState } from '@store';

import { TimeUtils } from '../helpers/TimeUtils';
import { DailyForecastData } from '../store/types';

const getFilteredData = (data?: DailyForecastData) => {
  if (!data?.daypart?.length) {
    return [];
  }
  /**
   * Check whether to display "Today" or "Tonight" data when "Today" tile is selected based on API response
   * If every element in daypart[0] is null, then assume it's past 3PM and to display "Tonight"
   */

  const isPast3PM = Object.values(data.daypart[0])
    .map(array => array[0])
    .every(element => !element);

  const { daypartName, iconCodeExtend, precipChance, precipType, temperature } = data.daypart[0];
  const { validTimeUtc, dayOfWeek } = data;

  const days = 7;

  return Array.from({ length: days }, (_, index) => {
    const modifiedIndex = index * 2;

    const dayOfWeekDate = TimeUtils.dateFromEpoch(validTimeUtc[index]);

    return {
      key: validTimeUtc[index],
      dayOfWeekToday: dayOfWeek[index],
      daypartName: daypartName[modifiedIndex],
      iconCodeExtend: iconCodeExtend[modifiedIndex],
      temperatureHigh: temperature[modifiedIndex],
      temperatureLow: temperature[modifiedIndex + 1],
      precipChance: isPast3PM ? precipChance[modifiedIndex + 1] : precipChance[modifiedIndex],
      precipType: precipType[modifiedIndex],
      dayAbbreviation: validTimeUtc[index] ? TimeUtils.dayOfWeekAbbr(dayOfWeekDate) : null,
    };
  });
};

export const useThreeDayForecast = () => {
  const { data } = useRecoilValue(dailyForecastState);

  return useMemo(() => {
    if (!data) {
      return [];
    }
    const filteredData = getFilteredData(data);

    // Slice the data to get the next three days, excluding today and tomorrow
    const fromDays = 2;
    const toDays = 5;

    return filteredData.slice(fromDays, toDays);
  }, [data]);
};
